document.addEventListener("DOMContentLoaded", () => {

  const noscript = document.querySelector('noscript[data-bstr-swatch]');
  if (!noscript) return;

  let variants = {};
  try {
    variants = JSON.parse(noscript.textContent.trim());
  } catch (e) {
    console.error("Variant JSON parse error", e);
    return;
  }

  function getActiveOption(optionIndex) {
    const active = document.querySelector(
      `[data-swatch-index$="-${optionIndex}"].swatch--active`
    );
    return active ? active.getAttribute("data-swatch-option") : null;
  }

  function updateColorSwatches() {
    const activeStyle = getActiveOption(0); // option 0 = Style
    if (!activeStyle) return;

    document.querySelectorAll('.swatch--color[data-swatch-option]').forEach(swatch => {
      const color = swatch.getAttribute("data-swatch-option");

      const match = Object.values(variants).find(v =>
        v.options.includes(activeStyle) &&
        v.options.includes(color)
      );

      if (!match || !match.id) return;


      if (match && match.featured_image && match.featured_image.src) {
        const src = match.featured_image.src.replace(/_(\d+x\d+)?\./, "_300x300.");
        swatch.style.backgroundImage = `url(${src})`;
        swatch.style.backgroundSize = "cover";
        swatch.style.backgroundPosition = "top center";
      }
    });
  }

  document.addEventListener("click", e => {
    if (e.target.closest("[data-swatch-option]")) {
      setTimeout(updateColorSwatches, 50);
    }
  });

  updateColorSwatches();
});
document.addEventListener('DOMContentLoaded', function () {
  function initSwipeArrow() {
    var slider = document.querySelector('.slider--product');
    var arrow = document.querySelector('.mc-swipe-arrow');
    if (!slider || !arrow) return false;

    function getSlides() {
      return Array.prototype.slice.call(slider.querySelectorAll('.slide--product'));
    }

    function getIndex() {
      // 1) attribute-based (als Booster dit gebruikt)
      var cur = slider.getAttribute('data-bstr-slider-current');
      if (cur !== null && cur !== '') {
        var n = parseInt(cur, 10);
        if (!isNaN(n)) return n;
      }

      // 2) active marker op slide (Booster variant)
      var slides = getSlides();
      var activeEl =
        slider.querySelector('.slide--product[data-bstr-slide="active"]') ||
        slider.querySelector('.slide--product.active') ||
        slider.querySelector('.slide--product.is-active');

      if (activeEl) {
        var idx = slides.indexOf(activeEl);
        if (idx >= 0) return idx;
      }

      // 3) fallback
      return 0;
    }

    function updateArrow() {
      var slides = getSlides();
      if (slides.length <= 1) {
        arrow.style.display = 'none';
        return;
      }
      var idx = getIndex();
      arrow.style.opacity = (idx < (slides.length - 1)) ? '1' : '0';
      arrow.style.pointerEvents = 'none';
    }

    updateArrow();

    // observe alles, want Booster wisselt soms attrs/classes
    var obs = new MutationObserver(function () {
      updateArrow();
    });

    obs.observe(slider, { attributes: true, childList: true, subtree: true });

    // extra: ook na swipe events (sommige builds triggeren dit)
    slider.addEventListener('touchend', function () {
      setTimeout(updateArrow, 60);
    });

    return true;
  }

  // retry omdat Booster soms later rendert
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (initSwipeArrow() || tries > 20) clearInterval(t);
  }, 150);
});

document.addEventListener('DOMContentLoaded', function () {
  function initCartOpenClass() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('input[data-minicart-input]'));
    if (!inputs.length) return;

    function update() {
      var open = inputs.some(function (i) { return i.checked; });
      document.body.classList.toggle('mc-cart-open', open);
    }

    // 1) normale changes
    inputs.forEach(function (i) {
      i.addEventListener('change', update);
    });

    // 2) als Booster programmatically checked togglet (soms zonder change)
    inputs.forEach(function (i) {
      new MutationObserver(update).observe(i, { attributes: true, attributeFilter: ['checked'] });
    });

    // 3) extra zekerheid: na elke click even opnieuw checken (overlay/close buttons)
    document.addEventListener('click', function () {
      setTimeout(update, 0);
    });

    // initial
    update();
  }

  initCartOpenClass();
});

document.addEventListener('DOMContentLoaded', function () {
  function enableMiniCartScroll() {
    var entries = document.querySelector('.minicart__entries');
    if (!entries) return;

    // Force styles (als Booster ze overschrijft)
    entries.style.overflowY = 'auto';
    entries.style.webkitOverflowScrolling = 'touch';
    entries.style.touchAction = 'pan-y';

    // iOS: als er ergens preventDefault op touchmove zit, stop propagation hier
    entries.addEventListener('touchmove', function (e) {
      e.stopPropagation();
    }, { passive: true });
  }

  enableMiniCartScroll();

  // Booster re-rendert minicart soms -> opnieuw toepassen
  document.addEventListener('click', function () {
    setTimeout(enableMiniCartScroll, 50);
    setTimeout(enableMiniCartScroll, 250);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  function isVisible(el){
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && window.getComputedStyle(el).display !== 'none';
  }

  function syncMiniCartState(){
    const holder = document.querySelector('.minicart__holder.minicart--drawer');
    const open = isVisible(holder);
    document.body.classList.toggle('mc-minicart-open', open);
  }

  // observe (Booster wisselt vaak style/class)
  const holder = document.querySelector('.minicart__holder.minicart--drawer');
  if (holder){
    new MutationObserver(function(){
      syncMiniCartState();
    }).observe(holder, { attributes: true, attributeFilter: ['class','style'] });
  }

  // fallback op clicks (ATC, close, qty +/-)
  document.addEventListener('click', function(){
    setTimeout(syncMiniCartState, 0);
    setTimeout(syncMiniCartState, 80);
    setTimeout(syncMiniCartState, 250);
  });

  syncMiniCartState();
});
document.addEventListener('DOMContentLoaded', function () {
  function isDrawerOpen() {
    const holder = document.querySelector('.minicart__holder.minicart--drawer');
    if (!holder) return false;

    const cs = window.getComputedStyle(holder);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;

    const r = holder.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function findStickyATC() {
    const els = Array.from(document.querySelectorAll('body *')).filter(el => {
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return false;

      const r = el.getBoundingClientRect();
      const isBottomBar = r.height > 80 && (window.innerHeight - r.bottom) < 8 && r.width > window.innerWidth * 0.7;
      if (!isBottomBar) return false;

      const txt = (el.innerText || '').toLowerCase();
      return txt.includes('toevoegen aan winkelwagen');
    });

    els.sort((a, b) => b.getBoundingClientRect().height - a.getBoundingClientRect().height);
    return els[0] || null;
  }

  function syncStickyVisibility() {
    if (window.innerWidth > 767) return;

    const open = isDrawerOpen();
    const sticky = findStickyATC();
    if (!sticky) return;

    if (open) {
      sticky.style.setProperty('display', 'none', 'important');
      sticky.dataset.mcHiddenByCart = '1';
    } else {
      if (sticky.dataset.mcHiddenByCart === '1') {
        sticky.style.removeProperty('display');
        delete sticky.dataset.mcHiddenByCart;
      }
    }
  }

  const holder = document.querySelector('.minicart__holder.minicart--drawer');
  if (holder) {
    new MutationObserver(syncStickyVisibility).observe(holder, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  document.addEventListener('click', function () {
    setTimeout(syncStickyVisibility, 0);
    setTimeout(syncStickyVisibility, 80);
    setTimeout(syncStickyVisibility, 250);
  });

  window.addEventListener('resize', function () {
    setTimeout(syncStickyVisibility, 50);
  });

  syncStickyVisibility();
});
document.addEventListener('DOMContentLoaded', function () {
  var sticky = document.querySelector('.sticky--mobile');
  var inputs = Array.prototype.slice.call(document.querySelectorAll('input[data-minicart-input]'));

  function apply() {
    if (!sticky) sticky = document.querySelector('.sticky--mobile');
    if (!sticky) return;

    var open = inputs.some(function (i) { return i.checked; });
    sticky.style.display = open ? 'none' : '';
  }

  if (!inputs.length) return;

  inputs.forEach(function(i){ i.addEventListener('change', apply); });
  document.addEventListener('click', function(){ setTimeout(apply, 0); setTimeout(apply, 80); });

  apply();
});

/* CETAMO – Decimalen killen (ook .00) incl. BESPAAR-tag
   Plak onderin custom.js
*/
(function () {
  const SEL = '.jsPrice, span.tag.tag--sale[data-tag-type="amount"]';

  function cleanMoneyText(text) {
    if (!text) return text;

    // pak zowel ,00 als .00, maar alleen als het bij een bedrag hoort
    // "€120,00" -> "€120"
    // "BESPAAR €40.00" -> "BESPAAR €40"
const isGerman = window.location.hostname.includes('cetamo-clothing.com');

let cleaned = text
  .replace(/(€\s?\d[\d.,]*)[,.]00\b/g, '$1')
  .replace(/\s+/g, ' ')
  .trim();

if (isGerman) {
  cleaned = cleaned.replace(/^BESPAAR\b/i, 'SPARE');
}

return cleaned;
  }

  function stripEl(el) {
    if (!el) return;
    const oldText = (el.textContent || '').trim();
    if (!oldText) return;

    const newText = cleanMoneyText(oldText);
    if (newText !== oldText) el.textContent = newText;
  }

  function stripAll(root = document) {
    root.querySelectorAll(SEL).forEach(stripEl);
  }

  function init() {
    // 1) direct
    stripAll();

    // 2) na swatch/variant klik: paar frames napoetsen zodat flits verdwijnt
    document.addEventListener(
      'click',
      (e) => {
        if (!e.target.closest('[data-swatch-option], .swatches__holder, .mc-swatch')) return;

        let frames = 0;
        const raf = () => {
          frames++;
          stripAll();
          if (frames < 14) requestAnimationFrame(raf);
        };
        requestAnimationFrame(raf);
      },
      true
    );

    // 3) observer: als theme opnieuw tekst injecteert (uw “BESPAAR €40.00” moment)
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        stripAll();
      }, 40);
    };

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') {
          m.addedNodes.forEach((n) => {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches(SEL)) stripEl(n);
            if (n.querySelector) stripAll(n);
          });
          schedule();
        }

        if (m.type === 'characterData') {
          const parent = m.target && m.target.parentElement;
          if (!parent) continue;
          const el = parent.closest && parent.closest(SEL);
          if (el) stripEl(el);
        }
      }
    });

    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  if (window.__CTM_STICKY_ATC_DIRECT__) return;
  window.__CTM_STICKY_ATC_DIRECT__ = true;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function findRealATC() {
    // uw normale ATC knop (exact match op uw outerHTML gedrag)
    return document.querySelector(
      'button[data-buy-button][onclick*="BoosterTheme.cart.addToCart"]'
    );
  }

  function closeStickyIfOpen() {
    const sticky = document.querySelector(".sticky--mobile");
    if (!sticky) return;
    sticky.classList.add("sticky--closed");
  }

  document.addEventListener("click", function (e) {
    if (!isMobile()) return;

    const stickyBtn = e.target.closest(
      'button.sticky--open__button[onclick*="BoosterTheme.ELEMENTS.stickyBuy"]'
    );
    if (!stickyBtn) return;

    // Alleen sticky gedrag blokkeren, niet de rest van de pagina
    e.preventDefault();

    // Laat Booster event loop eerst afronden, dan doen wij de echte ATC
    setTimeout(function () {
      const realATC = findRealATC();
      if (realATC) realATC.click();
      closeStickyIfOpen();
    }, 0);
  }, false);
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.__CTM_BODY_SPLIT_POLYFILL__) return;
  window.__CTM_BODY_SPLIT_POLYFILL__ = true;

  function toQueryStringFromEntries(entries) {
    const parts = [];
    for (const [k, v] of entries) {
      parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(String(v)));
    }
    return parts.join("&");
  }

  try {
    if (window.FormData && !FormData.prototype.split) {
      FormData.prototype.split = function (sep) {
        const qs = toQueryStringFromEntries(this.entries());
        return qs.split(sep);
      };
    }
  } catch (e) {}

  try {
    if (window.URLSearchParams && !URLSearchParams.prototype.split) {
      URLSearchParams.prototype.split = function (sep) {
        return this.toString().split(sep);
      };
    }
  } catch (e) {}
});
/* Kiwi Maatzoeker - DE */
(function () {
  if (!window.location.hostname.includes('cetamo-clothing.com')) return;

  function fixKiwiText() {
    document.querySelectorAll('._ks_text').forEach(function (el) {
      if (el.textContent.trim() === 'Maatzoeker') {
        el.textContent = 'Größenberater';
      }
    });
  }

  fixKiwiText();

  const observer = new MutationObserver(fixKiwiText);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setTimeout(fixKiwiText, 500);
  setTimeout(fixKiwiText, 1500);
  setTimeout(fixKiwiText, 3000);
})();
